import { http } from "../http"

class QuantityFetchApi {
    /**
     * Get quantity adjustments with optional filtering
     * @param {Object} options - Query parameters
     * @param {number} options.page - Page number (default: 1)
     * @param {number} options.limit - Items per page (default: 10)
     * @param {string} options.search - Optional search term
     * @returns {Promise} Promise with quantity adjustments data
     */
    static async getQuantityAdjustments(options = {}) {
        try {
            const params = {
                page: options.page || 1,
                limit: options.limit || 10,
                search: options.search || ''
            };

            const response = await http.get('/qty-adjustments', {
                params,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            return response.data;
        } catch (err) {
            console.error("Error fetching quantity adjustments:", err);
            throw err;
        }
    }

    /**
     * Get details for a specific quantity adjustment
     * @param {string} id - Quantity adjustment ID or name
     * @returns {Promise} Promise with quantity adjustment details
     */
    static async getQuantityAdjustmentDetails(id) {
        try {
            const response = await http.get(`/qty-adjustments/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            return response.data;
        } catch (err) {
            console.error("Error fetching quantity adjustment details:", err);
            throw err;
        }
    }

    /**
     * Create a new quantity adjustment
     * @param {Array} products - Array of products to adjust quantities for
     * @returns {Promise} Promise with created quantity adjustment data
     */
    static async createQuantityAdjustment(products) {
        try {
            const response = await http.post('/qty-adjustments', {
                addedProducts: products
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            return response.data;
        } catch (err) {
            console.error("Error creating quantity adjustment:", err);
            throw err;
        }
    }

    /**
     * Get user information by user ID
     * @param {string} userId - User ID
     * @returns {Promise} Promise with user data
     */
    static async getUserInfo(userId) {
        try {
            const response = await http.get(`/users/${userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            return response.data;
        } catch (err) {
            console.error("Error fetching user information:", err);
            throw err;
        }
    }

    /**
     * Flush all quantity adjustments (admin only)
     * @returns {Promise} Promise with delete confirmation
     */
    static async flushQuantityAdjustments() {
        try {
            const response = await http.delete('/qty-adjustments/flush', {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            return response.data;
        } catch (err) {
            console.error("Error flushing quantity adjustments:", err);
            throw err;
        }
    }
}

export default QuantityFetchApi;
